export const LIMIT = 500000;
export const DEBUG = true;
export const DFS_DEBUG = false;
export const CHOSEN_ARMOR_DEBUG = false;
export const SYNC = false;
export const DFS = true;
